import { render, staticRenderFns } from "./CTAGridScreen.vue?vue&type=template&id=2fadcfcd&scoped=true&"
import script from "./CTAGridScreen.vue?vue&type=script&lang=js&"
export * from "./CTAGridScreen.vue?vue&type=script&lang=js&"
import style0 from "./CTAGridScreen.vue?vue&type=style&index=0&id=2fadcfcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fadcfcd",
  null
  
)

export default component.exports